import { render, staticRenderFns } from "./ReleaseLog.vue?vue&type=template&id=594411fc&scoped=true&"
var script = {}
import style0 from "./ReleaseLog.vue?vue&type=style&index=0&id=594411fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594411fc",
  null
  
)

export default component.exports